import Icon from '../Icon';
import React from 'react';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { breakpoint } from '../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import Button from '../Button';
import { section } from '../../styling/utils/grid';

const StyledEmptyCart = styled.div`
  ${section}
  display: flex;
  justify-content: center;
  align-items: center;

  .empty-cart-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 768px;
    width: 100%;
    padding: 80px 0;

    ${breakpoint('large')} {
      padding: 240px 0;
    }
  }

  .icon {
    font-size: 7.2rem;
    margin-bottom: 0.8rem;
  }

  h1 {
    margin-bottom: 0.8rem;
    text-align: center;
  }

  .para {
    ${text('large')}
    text-align: center;
    margin-bottom: 2.4rem;
  }

  button {
    ${fontFamilyBold}
    text-transform: uppercase;
  }
`;

const EmptyCart = () => {
  const checkout = useTypedSelector((state) => state.checkout);
  const { emptyCartMessage, emptyCartLink } = checkout.payload;

  return (
    <StyledEmptyCart>
      <div className="empty-cart-content">
        <h1>{translate('checkout.empty.title')}</h1>
        {emptyCartMessage && (
          <div
            className="para"
            dangerouslySetInnerHTML={{
              __html: emptyCartMessage,
            }}
          />
        )}
        {emptyCartLink && (
          <a href={emptyCartLink}>
            <Button btnType="outlined" btnSize="large">
              {translate('checkout.startshopping')}
            </Button>
          </a>
        )}
      </div>
    </StyledEmptyCart>
  );
};

export default EmptyCart;
